import { useAuth0 } from '@auth0/auth0-react'
import { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'

import DropdownArrow from 'src/assets/dropdown_arrow.png'
import TeamIconGrey from 'src/assets/team.svg'
import MenuPopup from 'src/components/common/menuPopup'
import UserDetailsContext from 'src/context/userDetailsContext'
import routes from 'src/routes'
import useLogout from 'src/utils/hooks/useLogout'

const MenuContent = () => {
    const { userDetails } = useContext(UserDetailsContext)
    const logout = useLogout()
    return (
        <>
            <div className="min-w-max bg-neutral-gray-400">
                <Link
                    to={`/settings/team/edit-member/${userDetails.id}`}
                    className="hover hidden cursor-pointer px-2 py-1 hover:bg-primary-red-500 hover:text-white lg:flex"
                >
                    My Profile
                </Link>

                <Link
                    to={routes.settings}
                    className="hover hidden cursor-pointer px-2 py-1 hover:bg-primary-red-500 hover:text-white lg:flex"
                >
                    Settings
                </Link>

                <p
                    className="mb-0 cursor-pointer px-2 py-1 hover:bg-primary-red-500"
                    onClick={async () => {
                        localStorage.removeItem('access_token')
                        localStorage.removeItem('userOrganizationId')
                        localStorage.removeItem('userOrganizations')
                        logout()
                    }}
                >
                    Sign out
                </p>
            </div>
        </>
    )
}

function UserMenu() {
    const { user } = useAuth0()
    const menuRef = useRef(null)

    return (
        <div ref={menuRef} className="relative inline-flex">
            <MenuPopup menuContent={<MenuContent />} domContainer={menuRef}>
                <div className="flex cursor-pointer items-center truncate px-2">
                    <div className="hidden text-base text-neutral-gray-50 lg:block">
                        {user && user.name}
                    </div>
                    <div className="text-base text-neutral-gray-50 lg:hidden">
                        <img
                            alt="bell"
                            src={TeamIconGrey}
                            className="h-6 w-6"
                        />
                    </div>
                    <img className="pl-2" src={DropdownArrow} />
                </div>
            </MenuPopup>
        </div>
    )
}

export default UserMenu
